/* Scoped to Suit-Up Trousers. Existing product bundle prototypes stay intact. */
(function(){
'use strict';
function mount(){
 var b=document.querySelector('fish-bundle[data-trouser-cross]');
 if(!b||!b.state||b.__crossBound)return false;
 var matrix=document.getElementById('fish-vm-tops-'+b.dataset.sectionId);if(!matrix)return false;
 var tops=JSON.parse(matrix.textContent);if(!tops.v.length)return false;
 b.__crossBound=true;b.trouserValues=b.o1Values.slice();b.topValues=[...new Set(tops.v.map(v=>v.o1))];b.topVariants=tops.v;
 b.variants=b.variants.concat(tops.v);tops.v.forEach(v=>{b.byKey[[v.o1,v.o2,v.o3].map(x=>String(x||'').trim().toLowerCase()).join('\u0000')]=v;});
 b.isCross=function(){return this.tiers[this.tierIdx].dataset.bundleMode==='cross';};
 var render=b.renderSlots,select=b.selectTier,update=b.update;
 b.renderSlots=function(el){
  el.innerHTML='';var self=this;
  this.state.slots.forEach(function(slot,i){
   var isTop=self.isCross()&&i===1,box=document.createElement('div');box.className='fish-slot';box.dataset.productRole=isTop?'top':'trouser';
   var title=document.createElement('div');title.className='fish-slot__title';title.dataset.slotTitle=i;box.appendChild(title);
   var im=document.createElement('img');im.className='fish-slot__thumb';im.dataset.slotThumb=i;im.alt=isTop?'Selected top only':'Selected trousers';box.appendChild(im);
   var picks=document.createElement('div');picks.className='fish-slot__pickers';picks.appendChild(self.pillRow(isTop?'Top style — top only':'Trouser color',isTop?self.topValues:self.trouserValues,i,'o1'));picks.appendChild(self.pillRow('Size',self.o2Values,i,'o2'));box.appendChild(picks);el.appendChild(box);
  });
 };
 b.selectTier=function(idx){
  select.call(this,idx);
  if(this.isCross()&&!this.topValues.includes(this.state.slots[1].o1)){
   var label=this.topValues[0],size=this.defaultO2(label);this.state.slots[1]={o1:label,o2:size,o3:this.defaultO3(label,size)};
  }
  this.renderSlots(this.tiers[idx].querySelector('[data-slots]'));this.update();
 };
 b.update=function(){
  update.call(this);
  if(this.isCross()){
   var slots=this.tiers[this.tierIdx].querySelectorAll('.fish-slot');
   slots.forEach((s,i)=>{var ttl=s.querySelector('[data-slot-title]');if(ttl)ttl.firstChild.textContent=i===1?'Top only ':'Trouser ';});
  }
 };
 /* Give the unopened cross tier truthful mixed-garment thumbnails. */
 var crossIdx=this;
 b.tiers.forEach((t,i)=>{if(t.dataset.bundleMode==='cross'){var o1=b.defaultO1(),o2=b.defaultO2(o1),top=b.topValues[0],topSize=b.defaultO2(top);b.tierPicks[i]=[{o1:o1,o2:o2,o3:b.defaultO3(o1,o2)},{o1:top,o2:topSize,o3:b.defaultO3(top,topSize)}];}});
 b.selectTier(b.tierIdx);return true;
}
customElements.whenDefined('fish-bundle').then(function(){if(mount())return;var n=0,t=setInterval(function(){if(mount()||++n>=80)clearInterval(t);},100);});
})();
